import { temaSec, useTema } from './tema';
import brandWordmark from './assets/panpa-wordmark.svg';
import { enumText } from './presentation';

type Props = {
  sections: readonly (readonly [string, string])[];
  groups: { title: string; keys: string[] }[];
  active: string;
  email: string;
  role: string;
  feedbackOpen: number | null;
  menuOpen: boolean;
  onMenu: () => void;
  onSearch: () => void;
  onNavigate: (key: string) => void;
  onLogout: () => void;
};

/** Inst DefaultHeader: marka/hesap satırı + yatay ana gezinme. */
export function InstHeader(props: Props) {
  const group = props.groups.find((item) => item.keys.includes(props.active));
  return (
    <header className="inst-header">
      <div className="inst-topbar inst-container">
        <button
          className="inst-brand"
          aria-label="Panpa genel bakış"
          onClick={() => props.onNavigate('stats')}
        >
          <img src={brandWordmark} alt="Panpa" />
          <span>Yönetim merkezi</span>
        </button>
        <div className="inst-tools">
          <button className="inst-search" onClick={props.onSearch} aria-label="Bölüme git">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              aria-hidden="true"
            >
              <circle cx="10" cy="10" r="6" />
              <path d="m15 15 5 5" />
            </svg>
            <span>Bölüm, oyuncu veya işlem ara</span>
            <kbd>⌘ K</kbd>
          </button>
          <button
            className="inst-inbox"
            onClick={() => props.onNavigate('feedback')}
            aria-label="Geri bildirimleri aç"
          >
            <svg
              width="21"
              height="21"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.7"
              aria-hidden="true"
            >
              <path d="M4 4h16v12H9l-5 4Z" />
              <path d="M8 8h8M8 12h5" />
            </svg>
            {props.feedbackOpen != null && props.feedbackOpen > 0 && (
              <span>{props.feedbackOpen}</span>
            )}
          </button>
          <details
            className="inst-account"
            onKeyDown={(event) => {
              if (event.key === 'Escape') {
                event.currentTarget.open = false;
                event.currentTarget.querySelector('summary')?.focus();
              }
            }}
          >
            <summary aria-label="Hesap menüsü">
              <span className="inst-avatar">{props.email.slice(0, 1).toLocaleUpperCase('tr')}</span>
              <span className="inst-account-label">
                Hesabım <span aria-hidden="true">⌄</span>
              </span>
            </summary>
            <div className="inst-account-panel">
              <strong>{props.email}</strong>
              <small>{enumText(props.role)}</small>
              <button
                onClick={(event) => {
                  event.currentTarget.closest('details')?.removeAttribute('open');
                  props.onNavigate('permissions');
                }}
              >
                Yetkilerim
              </button>
              <TemaSecici />
              <button onClick={props.onLogout}>Oturumu kapat</button>
            </div>
          </details>
          <button
            className="inst-menu-toggle"
            aria-controls="main-nav"
            aria-expanded={props.menuOpen}
            onClick={props.onMenu}
          >
            Bölümler
          </button>
        </div>
      </div>
      <div className="inst-navbar">
        <nav className="inst-container inst-main-menu" aria-label="Ana yönetim grupları">
          {props.groups.map((item) => (
            <button
              key={item.title}
              aria-current={item === group ? 'true' : undefined}
              onClick={() => props.onNavigate(item.keys[0]!)}
            >
              {item.title}
            </button>
          ))}
        </nav>
      </div>
      <nav className="inst-container inst-submenu" aria-label="Seçili grubun bölümleri">
        {props.sections
          .filter(([key]) => group?.keys.includes(key))
          .map(([key, label]) => (
            <button
              key={key}
              aria-current={key === props.active ? 'page' : undefined}
              onClick={() => props.onNavigate(key)}
            >
              {label}
            </button>
          ))}
      </nav>
    </header>
  );
}

/** Hesap menüsünde tema seçimi (docs/56 Faz 0). */
function TemaSecici() {
  const tema = useTema();
  return (
    <div className="tema-secici" role="group" aria-label="Tema">
      {(
        [
          ['acik', 'Açık'],
          ['koyu', 'Koyu'],
          ['sistem', 'Sistem'],
        ] as const
      ).map(([t, ad]) => (
        <button key={t} aria-pressed={tema === t} onClick={() => temaSec(t)}>
          {ad}
        </button>
      ))}
    </div>
  );
}
